import React, {Component} from 'react';
class Map extends Component{
  render(){
    return(
    <div id="map" role="application" />
    )
  }
}

export default Map;
